import React from 'react';
import NarwhalLogo from './narwhal-logo';
import ResultsModal from './results-modal';
import useRetirementCalculator from '../hooks/useRetirementCalculator';
import theme from '../styles/theme';
import Logo from '../assets/logo.svg';

const RetirementCalculator = () => {
  const {
    initialAmount,
    setInitialAmount,
    monthlyAmount,
    setMonthlyAmount,
    expectedReturn,
    setExpectedReturn,
    currentAge,
    setCurrentAge,
    retirementAge,
    setRetirementAge,
    inflation,
    setInflation,
    finalAmount,
    monthlyIncome,
    chartData,
    showResults,
    handleCalculate,
    closeModal
  } = useRetirementCalculator();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" style={{ backgroundColor: theme.colors.offwhite }}>
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-xl overflow-hidden">
        <div className="p-6 flex flex-col md:flex-row items-center justify-between" style={{ backgroundColor: theme.colors.azul }}>
          <div className="flex items-center mb-4 md:mb-0">
            <NarwhalLogo />
            <div className="ml-4">
              <img src={Logo} alt="Narwhal Capital" className="h-16 md:h-24" />
            </div>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-white text-center md:text-right">Calculadora de Aposentadoria</h2>
        </div>
        
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <label className="block text-gray-700 font-medium mb-2" htmlFor="initialAmount">
                  Aporte Inicial (R$)
                </label>
                <input
                  id="initialAmount"
                  type="number"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2"
                  style={{ focusRingColor: theme.colors.amarelo }}
                  value={initialAmount}
                  onChange={(e) => setInitialAmount(Number(e.target.value))}
                  min="0"
                />
              </div>
              
              <div>
                <label className="block text-gray-700 font-medium mb-2" htmlFor="monthlyAmount">
                  Aportes Mensais (R$)
                </label>
                <input
                  id="monthlyAmount"
                  type="number"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2"
                  value={monthlyAmount}
                  onChange={(e) => setMonthlyAmount(Number(e.target.value))}
                  min="0"
                />
              </div>
              
              <div>
                <label className="block text-gray-700 font-medium mb-2" htmlFor="expectedReturn">
                  Retorno Nominal Esperado ao Ano (%)
                </label>
                <input
                  id="expectedReturn"
                  type="number"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2"
                  value={expectedReturn}
                  onChange={(e) => setExpectedReturn(Number(e.target.value))}
                  min="0"
                  step="0.1"
                />
              </div>
            </div>
            
            <div className="space-y-4">
              <div>
                <label className="block text-gray-700 font-medium mb-2" htmlFor="currentAge">
                  Idade Atual
                </label>
                <input
                  id="currentAge"
                  type="number"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2"
                  value={currentAge}
                  onChange={(e) => setCurrentAge(Number(e.target.value))}
                  min="0"
                  max="120"
                />
              </div>
              
              <div>
                <label className="block text-gray-700 font-medium mb-2" htmlFor="retirementAge">
                  Idade para Aposentar
                </label>
                <input
                  id="retirementAge"
                  type="number"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2"
                  value={retirementAge}
                  onChange={(e) => setRetirementAge(Number(e.target.value))}
                  min={currentAge + 1}
                  max="120"
                />
              </div>
              
              <div>
                <label className="block text-gray-700 font-medium mb-2" htmlFor="inflation">
                  Inflação Esperada ao Ano (%)
                </label>
                <input
                  id="inflation"
                  type="number"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2"
                  value={inflation}
                  onChange={(e) => setInflation(Number(e.target.value))}
                  min="0"
                  step="0.1"
                />
              </div>
            </div>
          </div>
          
          <div className="mt-8 flex justify-center">
            <button
              onClick={handleCalculate}
              className="py-3 px-6 rounded-md shadow-md transition duration-300 text-lg font-bold"
              style={{ 
                backgroundColor: theme.colors.amarelo, 
                color: theme.colors.azul 
              }}
            >
              Calcule minha aposentadoria
            </button>
          </div>
        </div>
      </div>
      
      {/* Modal de Resultados */}
      <ResultsModal 
        showResults={showResults}
        closeModal={closeModal}
        finalAmount={finalAmount}
        monthlyIncome={monthlyIncome}
        chartData={chartData}
      />
    </div>
  );
};

export default RetirementCalculator;
